export default __webpack_public_path__ + "assets/favicon-32x32.5dc59497289ace109d175c1afeaadd5d.png";